export default __webpack_public_path__ + "static/media/project-capa-hr.32368de8.jpg";